// extracted by mini-css-extract-plugin
module.exports = {"wrap":"appbody_wrap__Ic9hh"};